import script from "./DynamicList.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicList.vue?vue&type=script&setup=true&lang=js"

import "./DynamicList.vue?vue&type=style&index=0&id=1882b82e&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1882b82e"]])

export default __exports__